<template>
  <div class="page">
    <!-- <div class="total-page">共{{current}}页</div> -->
    <el-pagination
      background
      :page-size='10'
      layout="prev, pager, next"
      @current-change="currentChange"
      :total="total">
    </el-pagination>
    <!-- <Page :total="total" :current="current" :page-size="pageSize" @on-change="changePage" size="small" /> -->
  </div>
</template>

<script>
export default {
  name: 'custom_page',
  props: {
    pageSize: {
      type: Number,
      default: 1
    },
    total: {
      type: Number,
      default: 0
    },
    current: {
      type: Number,
      default: 1
    }
  },
  methods: {
    currentChange (page) {
      // this.current = page
      this.$emit('update:current', page)
      this.$emit('on-change', page)
    }
  }
}
</script>

<style scoped>
  .page {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 30px;
  }
</style>
